import { createContext } from 'react'

export enum FeatureFlagLoadState {
  LOADING = 'loading',
  READY = 'ready',
  UNAVAILABLE = 'unavailable',
}

// Isolated components and Storybook use defaults without waiting for a network client.
export const FeatureFlagLoadStateContext = createContext(FeatureFlagLoadState.UNAVAILABLE)
